import { render, staticRenderFns } from "./STT.vue?vue&type=template&id=05fa2f94&scoped=true"
import script from "./STT.vue?vue&type=script&lang=js"
export * from "./STT.vue?vue&type=script&lang=js"
import style0 from "./STT.vue?vue&type=style&index=0&id=05fa2f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fa2f94",
  null
  
)

export default component.exports